/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2100
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
